export default __webpack_public_path__ + "static/Lydia-ca9c0791d9b077a82051971d4d34892c464dc4f0276242d2200087292839c2bb.svg";